import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/tasks/$id')({
  beforeLoad: ({ params }) => {
    throw redirect({ to: '/tasks/item/$id', params });
  },
});
